import type { FormRadioGroupProps } from '../types';
import type { FieldValues } from 'react-hook-form';

import { InputLabel } from '@/components/InputLabel';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';

import { cn } from '@/lib/utils';

import { FormFieldShell } from '../FormFieldShell';

export const FormRadioGroup = <TFieldValues extends FieldValues = FieldValues>(
  props: FormRadioGroupProps<TFieldValues>,
) => {
  const {
    name,
    label,
    description,
    hint,
    isRequired,
    options,
    disabled,
    className,
  } = props;

  return (
    <FormFieldShell
      name={name}
      description={description}
      render={({ field, fieldState, fieldId }) => (
        <>
          {label && (
            <InputLabel
              htmlFor={fieldId}
              label={label}
              hint={hint}
              isRequired={isRequired}
              isInvalid={fieldState.invalid}
            />
          )}
          <RadioGroup
            id={fieldId}
            aria-label={label}
            aria-invalid={fieldState.invalid}
            className={cn('flex flex-wrap gap-4', className)}
            value={field.value ? String(field.value) : ''}
            onValueChange={field.onChange}
            disabled={disabled}
          >
            {options.map((option) => (
              <div
                key={option.id}
                className="flex items-center gap-2"
              >
                <RadioGroupItem
                  id={`${fieldId}-${option.id}`}
                  value={String(option.id)}
                />
                <Label htmlFor={`${fieldId}-${option.id}`}>{option.name}</Label>
              </div>
            ))}
          </RadioGroup>
        </>
      )}
    />
  );
};
